// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UvjQ","colBig":"styles_colBig__29omn","colSmall":"styles_colSmall__1zupn"};